import React from "react";
import PropTypes from "prop-types";
import { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import FormTextField from "components/form/form-textfield";
import FormSelect from "components/form/form-select";
import { CardWithDelete } from "components/card";

const EventEmailReceipt = ({ index, collectionName, element, onChange, onDelete, intl, availableLocales }) => {
  return <CardWithDelete onDelete={onDelete}>
    <DataGridItem>
      <FormTextField
          type="text"
          id={`${collectionName}.${index}.email`}
          name={`${collectionName}.${index}.email`}
          value={element.email}
          onChange={onChange}
          label={intl.formatMessage({id: "event.emailReceipt.email"})}
      />
    </DataGridItem>
    <DataGridItem>
      <FormSelect
          label={intl.formatMessage({id: "event.emailReceipt.locale"})}
          getLabelFromElement={item => item.label}
          getValueFromElement={item => item.value}
          id={`${collectionName}.${index}.locale`}
          name={`${collectionName}.${index}.locale`}
          value={element.locale}
          onChange={onChange}
          elements={availableLocales}
      />
    </DataGridItem>
  </CardWithDelete>
}


EventEmailReceipt.propTypes = {
  /**
   * Lista de locales disponibles en la aplicación
   */
  availableLocales: PropTypes.array,
  /**
   * Índice del elemento en la colección
   */
  index: PropTypes.number,
  /**
   * Nombre de la colección
   */
  collectionName: PropTypes.string,
  /**
   * Función que se invoca al modificar algún valor
   */
  onChange: PropTypes.func,
  /**
   * Función que se invoca al eliminar el contacto del formulario
   */
  onDelete: PropTypes.func,
  /**
   * Objeto con los valores que se quieren representar
   */
  element: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

export default injectIntl(EventEmailReceipt);
